import '../../css/site.css';

import { createSiteI18n } from '@/client/i18n';
import { captureInstallPrompt } from '@/lib/installApp';
import type { SitePageProps } from '@/client/types';
import { rememberUtm } from '@/client/utm';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => title || appName,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        // The shared PageProps type describes the admin panel, the site has its own props.
        const { locale, mainLocale } = props.initialPage.props as unknown as SitePageProps;

        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(createSiteI18n(locale, mainLocale))
            .mount(el);
    },
    progress: {
        color: 'var(--primary)',
    },
});

captureInstallPrompt();
rememberUtm();

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js');
}
